import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { pathToModel } from '../../../utils/dato.utils';
import useRegionSelector from '../../../hooks/useRegionSelector';

const Link = ({ to = {}, params = null, children, ...rest }) => {
  const { region } = useRegionSelector();

  if (to?.externalUrl) {
    return (
      <a href={to.externalUrl} target="_blank" {...rest}>
        {children}
      </a>
    );
  }

  const { model, slug } = to?.link || to || {};
  let url = pathToModel(model, slug, to?.region);

  const prevPath = typeof window !== 'undefined' ? window.location.pathname : '';

  if (to?.withMultipleRegions) {
    url = `/${region.toLowerCase()}${url}`;
  }

  return (
    <GatsbyLink activeClassName="active-link" to={url} state={{ prevPath, params }} {...rest}>
      {children}
    </GatsbyLink>
  );
};

export default Link;
